module.exports = __webpack_public_path__ + "static/img/global_app_access_img_2.c4bb647.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_app_access_img_2.jpg
// module id = TIJy
// module chunks = 0